
import { defineComponent } from 'vue';
import exAxios from '../../services/maps/exios.services';
import Loading from '../../components/ui/Loading.vue';
import mapManager from '../../services/maps/mapManager.services';
declare let naver: any;

export default defineComponent({
  name: 'Map',
  components: { Loading },
  data() {
    return {
      pointData: [
        {
          obsPostId: 'DT_0019',
          oldId: '7',
          obsPostName: '가덕도',
          obsLat: 35.024167,
          obsLon: 128.810833,
        },
        {
          obsPostId: 'SO_0737',
          oldId: '2032',
          obsPostName: '강구항',
          obsLat: 36.358583,
          obsLon: 129.391306,
        },
        {
          obsPostId: 'SO_0577',
          oldId: '194',
          obsPostName: '가거도',
          obsLat: 34.050833,
          obsLon: 125.128889,
        },
        {
          obsPostId: 'SO_0581',
          oldId: '1014',
          obsPostName: '강양항',
          obsLat: 35.39,
          obsLon: 129.344722,
        },
        {
          obsPostId: 'DT_0032',
          oldId: '282',
          obsPostName: '강화대교',
          obsLat: 37.7319444444444,
          obsLon: 126.522222222222,
        },
        {
          obsPostId: 'SO_0733',
          oldId: '2028',
          obsPostName: '강릉항',
          obsLat: 37.772278,
          obsLon: 128.951333,
        },
        {
          obsPostId: 'DT_0031',
          oldId: '10',
          obsPostName: '거문도',
          obsLat: 34.028333,
          obsLon: 127.308889,
        },
        {
          obsPostId: 'DT_0029',
          oldId: '275',
          obsPostName: '거제도',
          obsLat: 34.801389,
          obsLon: 128.699167,
        },
        {
          obsPostId: 'SO_0539',
          oldId: '601',
          obsPostName: '강화외포',
          obsLat: 37.700833,
          obsLon: 126.3725,
        },
        {
          obsPostId: 'SO_0571',
          oldId: '1007',
          obsPostName: '거제외포',
          obsLat: 34.939444,
          obsLon: 128.718056,
        },
        {
          obsPostId: 'DT_0058',
          oldId: '462',
          obsPostName: '경인항',
          obsLat: 37.560833,
          obsLon: 126.601111,
        },
        {
          obsPostId: 'SO_0552',
          oldId: '1100',
          obsPostName: '고현항',
          obsLat: 34.901944,
          obsLon: 128.622222,
        },
        {
          obsPostId: 'SO_0570',
          oldId: '1006',
          obsPostName: '광암항',
          obsLat: 35.1025,
          obsLon: 128.498889,
        },
        {
          obsPostId: 'DT_0026',
          oldId: '92',
          obsPostName: '고흥발포',
          obsLat: 34.481111,
          obsLon: 127.342778,
        },
        {
          obsPostId: 'DT_0049',
          oldId: '60',
          obsPostName: '광양',
          obsLat: 34.903672,
          obsLon: 127.754836,
        },
        {
          obsPostId: 'DT_0042',
          oldId: '360',
          obsPostName: '교본초',
          obsLat: 34.7047222222222,
          obsLon: 128.306388888889,
        },
        {
          obsPostId: 'SO_0564',
          oldId: '1000',
          obsPostName: '국화도',
          obsLat: 37.060556,
          obsLon: 126.560556,
        },
        {
          obsPostId: 'DT_0018',
          oldId: '18',
          obsPostName: '군산',
          obsLat: 35.975556,
          obsLon: 126.563056,
        },
        {
          obsPostId: 'DT_0038',
          oldId: '356',
          obsPostName: '굴업도',
          obsLat: 37.194444,
          obsLon: 125.995,
        },
        {
          obsPostId: 'SO_0734',
          oldId: '2029',
          obsPostName: '궁촌항',
          obsLat: 37.327806,
          obsLon: 129.270028,
        },
        {
          obsPostId: 'SO_0550',
          oldId: '1101',
          obsPostName: '나로도',
          obsLat: 34.463056,
          obsLon: 127.453889,
        },
        {
          obsPostId: 'SO_0732',
          oldId: '2027',
          obsPostName: '남애항',
          obsLat: 37.944222,
          obsLon: 128.788333,
        },
        {
          obsPostId: 'SO_0569',
          oldId: '1005',
          obsPostName: '남포항',
          obsLat: 34.957778,
          obsLon: 128.321667,
        },
        {
          obsPostId: 'NS_0003',
          oldId: '43',
          obsPostName: '녹동',
          obsLat: 34.527028,
          obsLon: 127.134528,
        },
        {
          obsPostId: 'SO_0712',
          oldId: '2025',
          obsPostName: '능양항',
          obsLat: 34.812222,
          obsLon: 128.245,
        },
        {
          obsPostId: 'SO_0731',
          oldId: '2026',
          obsPostName: '대진항',
          obsLat: 38.501389,
          obsLon: 128.426167,
        },
        {
          obsPostId: 'DT_0017',
          oldId: '220',
          obsPostName: '대산',
          obsLat: 37.0075,
          obsLon: 126.352778,
        },
        {
          obsPostId: 'DT_0036',
          oldId: '344',
          obsPostName: '대청도',
          obsLat: 37.825222,
          obsLon: 124.718056,
        },
        {
          obsPostId: 'DT_0047',
          oldId: '455',
          obsPostName: '도농탄',
          obsLat: 33.158056,
          obsLon: 126.274722,
        },
        {
          obsPostId: 'SO_0536',
          oldId: '995',
          obsPostName: '덕적도',
          obsLat: 37.227778,
          obsLon: 126.157778,
        },
        {
          obsPostId: 'SO_0739',
          oldId: '2034',
          obsPostName: '도장항',
          obsLat: 34.367306,
          obsLon: 127.011972,
        },
        {
          obsPostId: 'DT_0040',
          oldId: '359',
          obsPostName: '독도',
          obsLat: 37.238889,
          obsLon: 131.867222,
        },
        {
          obsPostId: 'DT_0057',
          oldId: '461',
          obsPostName: '동해항',
          obsLat: 37.494722,
          obsLon: 129.143889,
        },
        {
          obsPostId: 'SO_0709',
          oldId: '2022',
          obsPostName: '두문포',
          obsLat: 34.643611,
          obsLon: 127.7975,
        },
        {
          obsPostId: 'SO_0703',
          oldId: '2016',
          obsPostName: '땅끝항',
          obsLat: 34.298889,
          obsLon: 126.531111,
        },
        {
          obsPostId: 'SO_0705',
          oldId: '2018',
          obsPostName: '마량항',
          obsLat: 34.448889,
          obsLon: 126.821944,
        },
        {
          obsPostId: 'DT_0062',
          oldId: '466',
          obsPostName: '마산',
          obsLat: 35.1975,
          obsLon: 128.576389,
        },
        {
          obsPostId: 'SO_0547',
          oldId: '1102',
          obsPostName: '말도',
          obsLat: 35.855278,
          obsLon: 126.318333,
        },
        {
          obsPostId: 'DT_0023',
          oldId: '238',
          obsPostName: '모슬포',
          obsLat: 33.214444,
          obsLon: 126.251111,
        },
        {
          obsPostId: 'DT_0007',
          oldId: '15',
          obsPostName: '목포',
          obsLat: 34.779722,
          obsLon: 126.375556,
        },
        {
          obsPostId: 'DT_0006',
          oldId: '2',
          obsPostName: '묵호',
          obsLat: 37.550278,
          obsLon: 129.116389,
        },
        {
          obsPostId: 'SO_0326',
          oldId: '326',
          obsPostName: '미조항',
          obsLat: 34.706389,
          obsLon: 128.048611,
        },
        {
          obsPostId: 'DT_0059',
          oldId: '463',
          obsPostName: '백령도',
          obsLat: 37.95565,
          obsLon: 124.736081,
        },
        {
          obsPostId: 'SO_0574',
          oldId: '1010',
          obsPostName: '백사장항',
          obsLat: 36.586389,
          obsLon: 126.315,
        },
        {
          obsPostId: 'SO_0568',
          oldId: '1004',
          obsPostName: '백야도',
          obsLat: 34.624444,
          obsLon: 127.632222,
        },
        {
          obsPostId: 'SO_0537',
          oldId: '996',
          obsPostName: '벽파진',
          obsLat: 34.539444,
          obsLon: 126.346111,
        },
        {
          obsPostId: 'DT_0025',
          oldId: '20',
          obsPostName: '보령',
          obsLat: 36.406389,
          obsLon: 126.486111,
        },
        {
          obsPostId: 'SO_0740',
          oldId: '2035',
          obsPostName: '보옥항',
          obsLat: 34.129,
          obsLon: 126.513556,
        },
        {
          obsPostId: 'DT_0041',
          oldId: '361',
          obsPostName: '복사초',
          obsLat: 34.0983333333333,
          obsLon: 126.168333333333,
        },
        {
          obsPostId: 'SO_0710',
          oldId: '2023',
          obsPostName: '봉우항',
          obsLat: 34.932778,
          obsLon: 127.9275,
        },
        {
          obsPostId: 'DT_0005',
          oldId: '6',
          obsPostName: '부산',
          obsLat: 35.096389,
          obsLon: 129.035278,
        },
        {
          obsPostId: 'DT_0056',
          oldId: '460',
          obsPostName: '부산항신항',
          obsLat: 35.0775,
          obsLon: 128.786944,
        },
        {
          obsPostId: 'DT_0061',
          oldId: '465',
          obsPostName: '삼천포',
          obsLat: 34.924167,
          obsLon: 128.069722,
        },
        {
          obsPostId: 'SO_0543',
          oldId: '1103',
          obsPostName: '서거차도',
          obsLat: 34.253611,
          obsLon: 125.917778,
        },
        {
          obsPostId: 'DT_0010',
          oldId: '14',
          obsPostName: '서귀포',
          obsLat: 33.24,
          obsLon: 126.561667,
        },
        {
          obsPostId: 'SO_0555',
          oldId: '1104',
          obsPostName: '서망항',
          obsLat: 34.366667,
          obsLon: 126.134167,
        },
        {
          obsPostId: 'DT_0051',
          oldId: '458',
          obsPostName: '서천마량',
          obsLat: 36.1288888888889,
          obsLon: 126.495277777778,
        },
        {
          obsPostId: 'DT_0022',
          oldId: '237',
          obsPostName: '성산포',
          obsLat: 33.474722,
          obsLon: 126.927778,
        },
        {
          obsPostId: 'SO_0578',
          oldId: '1013',
          obsPostName: '소매물도',
          obsLat: 34.621944,
          obsLon: 128.548056,
        },
        {
          obsPostId: 'SO_0704',
          oldId: '2017',
          obsPostName: '소안항',
          obsLat: 34.15,
          obsLon: 126.631944,
        },
        {
          obsPostId: 'DT_0012',
          oldId: '35',
          obsPostName: '속초',
          obsLat: 38.207222,
          obsLon: 128.594167,
        },
        {
          obsPostId: 'SO_0566',
          oldId: '1002',
          obsPostName: '송공항',
          obsLat: 34.848333,
          obsLon: 126.225278,
        },
        {
          obsPostId: 'DT_0048',
          oldId: '456',
          obsPostName: '속초등표',
          obsLat: 38.199478,
          obsLon: 128.613083,
        },
        {
          obsPostId: 'SO_0562',
          oldId: '998',
          obsPostName: '승봉도',
          obsLat: 37.169722,
          obsLon: 126.290556,
        },
        {
          obsPostId: 'SO_0567',
          oldId: '1003',
          obsPostName: '쉬미항',
          obsLat: 34.504722,
          obsLon: 126.183611,
        },
        {
          obsPostId: 'SO_0707',
          oldId: '2020',
          obsPostName: '시산항',
          obsLat: 34.394444,
          obsLon: 127.261667,
        },
        {
          obsPostId: 'SO_0576',
          oldId: '1011',
          obsPostName: '시하도',
          obsLat: 34.661111,
          obsLon: 126.256944,
        },
        {
          obsPostId: 'IE_0061',
          oldId: '287',
          obsPostName: '신안가거초',
          obsLat: 33.941944,
          obsLon: 124.592778,
        },
        {
          obsPostId: 'DT_0046',
          oldId: '454',
          obsPostName: '쌍정초',
          obsLat: 37.556161,
          obsLon: 130.939211,
        },
        {
          obsPostId: 'SO_0708',
          oldId: '2021',
          obsPostName: '안도항',
          obsLat: 34.479722,
          obsLon: 127.797778,
        },
        {
          obsPostId: 'SO_0538',
          oldId: '997',
          obsPostName: '안마도',
          obsLat: 35.345556,
          obsLon: 126.016111,
        },
        {
          obsPostId: 'DT_0008',
          oldId: '211',
          obsPostName: '안산',
          obsLat: 37.192222,
          obsLon: 126.647222,
        },
        {
          obsPostId: 'DT_0034',
          oldId: '21',
          obsPostName: '안흥',
          obsLat: 36.673611,
          obsLon: 126.132222,
        },
        {
          obsPostId: 'SO_0573',
          oldId: '1009',
          obsPostName: '양포항',
          obsLat: 35.881389,
          obsLon: 129.5275,
        },
        {
          obsPostId: 'DT_0037',
          oldId: '343',
          obsPostName: '어청도',
          obsLat: 36.117222,
          obsLon: 125.984722,
        },
        {
          obsPostId: 'SO_0551',
          oldId: '1105',
          obsPostName: '여서도',
          obsLat: 33.988056,
          obsLon: 126.923333,
        },
        {
          obsPostId: 'DT_0016',
          oldId: '9',
          obsPostName: '여수',
          obsLat: 34.747222,
          obsLon: 127.765556,
        },
        {
          obsPostId: 'SO_0738',
          oldId: '2033',
          obsPostName: '여호항',
          obsLat: 34.661556,
          obsLon: 127.469556,
        },
        {
          obsPostId: 'DT_0060',
          oldId: '464',
          obsPostName: '연평도',
          obsLat: 37.657669,
          obsLon: 125.714417,
        },
        {
          obsPostId: 'DT_0003',
          oldId: '208',
          obsPostName: '영광',
          obsLat: 35.426111,
          obsLon: 126.420556,
        },
        {
          obsPostId: 'DT_0044',
          oldId: '365',
          obsPostName: '영종대교',
          obsLat: 37.5455555555556,
          obsLon: 126.584444444444,
        },
        {
          obsPostId: 'SO_0554',
          oldId: '1106',
          obsPostName: '영종왕산',
          obsLat: 37.458056,
          obsLon: 126.358889,
        },
        {
          obsPostId: 'DT_0043',
          oldId: '364',
          obsPostName: '영흥도',
          obsLat: 37.2386111111111,
          obsLon: 126.428611111111,
        },
        {
          obsPostId: 'SO_0702',
          oldId: '2015',
          obsPostName: '옥도',
          obsLat: 34.350833,
          obsLon: 126.018611,
        },
        {
          obsPostId: 'IE_0062',
          oldId: '288',
          obsPostName: '옹진소청초',
          obsLat: 37.423056,
          obsLon: 124.738056,
        },
        {
          obsPostId: 'DT_0027',
          oldId: '44',
          obsPostName: '완도',
          obsLat: 34.315556,
          obsLon: 126.759722,
        },
        {
          obsPostId: 'DT_0039',
          oldId: '357',
          obsPostName: '왕돌초',
          obsLat: 36.7191666666667,
          obsLon: 129.7325,
        },
        {
          obsPostId: 'SO_0548',
          oldId: '1107',
          obsPostName: '우이도',
          obsLat: 34.620556,
          obsLon: 125.856667,
        },
        {
          obsPostId: 'SO_0563',
          oldId: '999',
          obsPostName: '울도',
          obsLat: 37.035556,
          obsLon: 125.995,
        },
        {
          obsPostId: 'DT_0013',
          oldId: '3',
          obsPostName: '울릉도',
          obsLat: 37.491389,
          obsLon: 130.913611,
        },
        {
          obsPostId: 'DT_0020',
          oldId: '5',
          obsPostName: '울산',
          obsLat: 35.501944,
          obsLon: 129.387222,
        },
        {
          obsPostId: 'ET_0013',
          oldId: '34',
          obsPostName: '원산',
          obsLat: 39.366667,
          obsLon: 127.45,
        },
        {
          obsPostId: 'DT_0030',
          oldId: '17',
          obsPostName: '위도',
          obsLat: 35.618056,
          obsLon: 126.301667,
        },
        {
          obsPostId: 'SO_0572',
          oldId: '1008',
          obsPostName: '읍천항',
          obsLat: 35.690833,
          obsLon: 129.475556,
        },
        {
          obsPostId: 'IE_0060',
          oldId: '286',
          obsPostName: '이어도',
          obsLat: 32.1227777777778,
          obsLon: 125.182222222222,
        },
        {
          obsPostId: 'DT_0001',
          oldId: '78',
          obsPostName: '인천',
          obsLat: 37.451944,
          obsLon: 126.592222,
        },
        {
          obsPostId: 'DT_0052',
          oldId: '459',
          obsPostName: '인천송도',
          obsLat: 37.3380555555556,
          obsLon: 126.586111111111,
        },
        {
          obsPostId: 'DT_0024',
          oldId: '241',
          obsPostName: '장항',
          obsLat: 36.006944,
          obsLon: 126.6875,
        },
        {
          obsPostId: 'SO_0735',
          oldId: '2030',
          obsPostName: '죽변항',
          obsLat: 37.054833,
          obsLon: 129.423917,
        },
        {
          obsPostId: 'DT_0004',
          oldId: '13',
          obsPostName: '제주',
          obsLat: 33.5275,
          obsLon: 126.543056,
        },
        {
          obsPostId: 'DT_0028',
          oldId: '276',
          obsPostName: '진도',
          obsLat: 34.377778,
          obsLon: 126.308611,
        },
        {
          obsPostId: 'SO_0711',
          oldId: '2024',
          obsPostName: '창선도',
          obsLat: 34.840556,
          obsLon: 128.019444,
        },
        {
          obsPostId: 'DT_0054',
          oldId: '509',
          obsPostName: '진해',
          obsLat: 35.147222,
          obsLon: 128.643056,
        },
        {
          obsPostId: 'SO_0699',
          oldId: '2012',
          obsPostName: '천리포항',
          obsLat: 36.803889,
          obsLon: 126.146944,
        },
        {
          obsPostId: 'SO_0706',
          oldId: '2019',
          obsPostName: '청산도',
          obsLat: 34.180833,
          obsLon: 126.856111,
        },
        {
          obsPostId: 'SO_0549',
          oldId: '1108',
          obsPostName: '초도',
          obsLat: 34.240556,
          obsLon: 127.245278,
        },
        {
          obsPostId: 'DT_0050',
          oldId: '457',
          obsPostName: '태안',
          obsLat: 36.9130555555556,
          obsLon: 126.238888888889,
        },
        {
          obsPostId: 'DT_0021',
          oldId: '12',
          obsPostName: '추자도',
          obsLat: 33.961944,
          obsLon: 126.300278,
        },
        {
          obsPostId: 'SO_0736',
          oldId: '2031',
          obsPostName: '축산항',
          obsLat: 36.509944,
          obsLon: 129.448139,
        },
        {
          obsPostId: 'DT_0014',
          oldId: '8',
          obsPostName: '통영',
          obsLat: 34.827778,
          obsLon: 128.434722,
        },
        {
          obsPostId: 'DT_0002',
          oldId: '50',
          obsPostName: '평택',
          obsLat: 36.966944,
          obsLon: 126.822778,
        },
        {
          obsPostId: 'DT_0901',
          oldId: '901',
          obsPostName: '포항',
          obsLat: 36.051581,
          obsLon: 129.374499,
        },
        {
          obsPostId: 'SO_0553',
          oldId: '1109',
          obsPostName: '해운대',
          obsLat: 35.1602777777778,
          obsLon: 129.1915,
        },
        {
          obsPostId: 'SO_0565',
          oldId: '1001',
          obsPostName: '향화도항',
          obsLat: 35.167778,
          obsLon: 126.359444,
        },
        {
          obsPostId: 'SO_0700',
          oldId: '2013',
          obsPostName: '호도',
          obsLat: 36.303889,
          obsLon: 126.264722,
        },
        {
          obsPostId: 'SO_0540',
          oldId: '1110',
          obsPostName: '호산항',
          obsLat: 37.176111,
          obsLon: 129.342778,
        },
        {
          obsPostId: 'SO_0701',
          oldId: '2014',
          obsPostName: '홍도항',
          obsLat: 34.681111,
          obsLon: 125.195,
        },
        {
          obsPostId: 'DT_0011',
          oldId: '218',
          obsPostName: '후포',
          obsLat: 36.6775,
          obsLon: 129.453056,
        },
        {
          obsPostId: 'DT_0035',
          oldId: '16',
          obsPostName: '흑산도',
          obsLat: 34.684167,
          obsLon: 125.435556,
        },
      ],
      observers: [
        { value: '', label: '조회' },
        { value: 'ALL', label: '전체' },
        { value: 'SGMA_POINT', label: 'SGMA POINT' },
        { value: 'DIFF', label: '개정수' },
      ],
      windowHeight: 0,
      isLoading: false,
      type: '',
      map: {} as any,
      searchResults: [],
      totalPointsCount: 0,
      mapManagerController: {} as any,
    };
  },
  computed: {
    fullHeight(): string {
      return `height:${this.windowHeight}px`;
    },
    checkTotalPoints(): any {
      return (
        this.mapManagerController != null &&
        this.mapManagerController.getSpots() != null &&
        this.mapManagerController.getSpots().length > 0
      );
    },
  },
  mounted() {
    console.log('mounted');
    this.checkWindowHeight();
    this.loadNaverMapFromCDN();
  },
  methods: {
    gotoPoint(gotoPoint: any) {
      this.mapManagerController.gotoPoint(gotoPoint);
    },
    changeSearchKey(searchKey: any) {
      const str = searchKey.target.value;
      if (this.checkTotalPoints) {
        this.searchResults = this.mapManagerController
          .getSpots()
          .filter(
            (spot: { name: string | any[] }) => spot.name.indexOf(str) != -1,
          );
      }
    },
    loadNaverMapFromCDN() {
      const scriptTag = document.createElement('script');
      scriptTag.src =
        'https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=rsqbygeix2';
      scriptTag.onload = this.loadMap;
      document.getElementsByTagName('body')[0].appendChild(scriptTag);
    },
    checkWindowHeight() {
      this.windowHeight = document.body.offsetHeight;
      this.windowHeight = this.windowHeight - 50;
    },
    loadMap() {
      const mapOptions = {
        useStyleMap: true,
        center: new naver.maps.LatLng(33.38, 126.55),
        zoom: 11,
      };
      this.map = new naver.maps.Map('mapContainer', mapOptions);

      this.mapManagerController = mapManager(this.map, this);
      //   this.mapManagerController.mapClickEvent();

      this.pointData.forEach((point: any) => {
        const marker = new naver.maps.Marker({
          position: { lat: point.obsLat, lng: point.obsLon },
          title: `[${point.obsPostName}] ${point.obsPostId}`,
          draggable: false,
          map: this.map,
        });
        marker.addListener('click', () => {
          const infoWindow = new naver.maps.InfoWindow({
            content: `<div style="padding:5px 15px" >[${point.obsPostId}] ${point.obsPostName}</div>`,
          });
          infoWindow.open(this.map, marker);
        });
      });
    },
    removeMarkerAll() {
      this.mapManagerController.removeMarkerAll();
    },
    loadingAction(ck: boolean) {
      this.isLoading = ck;
    },
  },
});
